import { codemark } from './plugin';
export * from './types';
export default codemark;
//# sourceMappingURL=index.js.map